import { Button, Container, FormGroup, Input, Label, Select, Textarea } from "@/components"
import { FlexWrapper } from "@/components/layout/flex/flexWrapper"
import { useAxios } from "@/context/axiosContext"
import { useDialog } from "@/context/dialogContext"
import { useRedis } from "@/hooks/useRedis"
import { useEffect, useRef, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { Col, Row } from "styled-bootstrap-grid"
import commonUtils from '@/utils/commonUtils'
import { TInput } from "@/components/forms/form-elements/types"
import DataTable from "react-data-table-component"

interface DataRow {
  cmpnyCd: string
  chnlId: string
  regId: string
  regDate: string
  updId: string
  updDate: string
  chnlNm: string
  chnlDesc: string
  useYn: string
  useYnNm: string
  applyDate: string
  title: string
  customUrl: string
  publishedAt: string
  description: string
  thumbnailsDefault: string
  thumbnailsHigh: string
  thumbnailsMedium: string
  subscriberCount: string
  videoCount: string
  viewCount: string
  hiddenSubscriberCountYn: string
  likeCount: string
}

const DetailYoutubeHist: React.FC = () => {
  const axios = useAxios();
  const navigate = useNavigate();
  const location = useLocation();

  const [requestData] = useState({
    chnlId: location.state?.chnlId || '',
    applyDate: location.state?.applyDate || '',
  });
  const { getComCodes, getComCodeValue } = useRedis();
  const [youtube, setYoutube] = useState<DataRow>();
  const [hist, setHist] = useState<DataRow[]>([]);

  const { showAlert, showConfirm } = useDialog();

  const description = useRef<HTMLTextAreaElement>(null);

  const getHistYoutube = async () => {
    const response = await axios.post('/youtube/detailHist', {
      chnlId: requestData.chnlId,
      applyDate: requestData.applyDate,
    });

    if (response.status == 200) {
      if (response.data.data.data) {
        response.data.data.data.useYnNm = getComCodeValue('USE_YN', response.data.data.data.useYn)?.codeNm || '';
        setYoutube(response.data.data.data);
      }
      if(response.data.data.hist && Array.isArray(response.data.data.hist)){
        setHist(response.data.data.hist);
      }
    }
  };

  const resizeTextarea = (refArea: any) => {
    if (refArea && refArea.current) {
      refArea.current.style.height = 'auto';
      refArea.current.style.height = `${refArea.current.scrollHeight > 500 ? 500 : refArea.current.scrollHeight}px`;
    }
  }

  useEffect(() => {
    getHistYoutube();
    resizeTextarea(description);
  }, []);

  return (
    <>
      <div style={{ width: '100%', height: '100%', marginTop: '50px' }}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
            marginBottom: '10px',
            alignItems: 'center',
            marginTop: '50px',
          }}
        >
          <p style={{ marginLeft: '20px', fontSize: '20px' }}>유튜브채널이력상세</p>
          <FlexWrapper gap="20px">
            <Button
              onClick={() =>
                showConfirm({
                  title: '유튜브채널상세 화면으로 이동하시겠습니까?',
                  onConfirm() {
                    navigate('/youtube/detail', { state: { searchData: location.state?.searchData, chnlId: youtube?.chnlId,} });
                  },
                })
              }
              color="neverbe"
              variant="outlined"
            >
              돌아가기
            </Button>
          </FlexWrapper>
        </div>
      </div>
      <Container>
        <Row>
          <Col col={6}>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="chnlNm">
                채널명
              </Label>
              <Input
                id="chnlNm"
                name="chnlNm"
                type="text"
                value={youtube?.title || youtube?.chnlNm}
                disabled={true}
              />
            </FormGroup>
          </Col>
          <Col col={6}>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="chnlId">
                채널ID
              </Label>
              <Input
                id="chnlId"
                name="chnlId"
                type="text"
                value={youtube?.chnlId}
                disabled={true}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="customUrl">
                고객URL
              </Label>
              <Input
                id="customUrl"
                name="customUrl"
                type="text"
                value={youtube?.customUrl}
                disabled={true}
              />
            </FormGroup>
          </Col>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="useYn">
                개설일
              </Label>
              <Input
                id="useYn"
                name="useYn"
                type="text"
                value={commonUtils.formatDate(youtube?.publishedAt || '', true)}
                disabled={true}
              />
            </FormGroup>
          </Col>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="applyDate">
                적용일자
              </Label>
              <Input
                id="applyDate"
                name="applyDate"
                type="text"
                value={commonUtils.formatDate(youtube?.applyDate || '')}
                disabled={true}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="thumbnailsDefault">
                로고URL
              </Label>
              <Input
                id="thumbnailsDefault"
                name="thumbnailsDefault"
                type="text"
                value={youtube?.thumbnailsDefault}
                disabled={true}
              />
              <Input
                id="thumbnailsMedium"
                name="thumbnailsMedium"
                type="text"
                value={youtube?.thumbnailsMedium}
                disabled={true}
              />
              <Input
                id="thumbnailsHigh"
                name="thumbnailsHigh"
                type="text"
                value={youtube?.thumbnailsHigh}
                disabled={true}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col col style={{ height: 'maxContent' }}>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="description">
                채널설명
              </Label>
              <Textarea
                id="description"
                name="description"
                value={youtube?.description}
                disabled={true}
                height={'100%'}
                ref={description}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="subscriberCount">
                구독자수
              </Label>
              <Input
                id="subscriberCount"
                name="subscriberCount"
                type="text"
                value={(youtube?.subscriberCount?.toLocaleString() || 0)+'명'}
                disabled={true}
              />
            </FormGroup>
          </Col>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="viewCount">
                조회수
              </Label>
              <Input
                id="viewCount"
                name="viewCount"
                type="text"
                value={(youtube?.viewCount?.toLocaleString() || 0)+'회'}
                disabled={true}
              />
            </FormGroup>
          </Col>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="videoCount">
                동영상수
              </Label>
              <Input
                id="videoCount"
                name="videoCount"
                type="text"
                value={(youtube?.videoCount?.toLocaleString() || 0)+'개'}
                disabled={true}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="regId">
                등록자
              </Label>
              <Input
                id="regId"
                name="regId"
                type="text"
                value={youtube?.regId}
                disabled={true}
              />
            </FormGroup>
          </Col>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="chnlId">
                등록일시
              </Label>
              <Input
                id="regDate"
                name="regDate"
                type="text"
                value={commonUtils.formatDate(youtube?.regDate || '', true)}
                disabled={true}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="updId">
                수정자
              </Label>
              <Input
                id="updId"
                name="updId"
                type="text"
                value={youtube?.updId}
                disabled={true}
              />
            </FormGroup>
          </Col>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="updDate">
                수정일시
              </Label>
              <Input
                id="updDate"
                name="updDate"
                type="text"
                value={commonUtils.formatDate(youtube?.updDate || '', true)}
                disabled={true}
              />
            </FormGroup>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default DetailYoutubeHist;